export const SortableHeader = ({ column, label, sortConfig, onSort }) => {
  const isActive = sortConfig.key === column;

  return (
    <th
      onClick={() => onSort(column)}
      style={{ cursor: "pointer", userSelect: "none" }}
    >
      {label}
      {isActive && (sortConfig.direction === "asc" ? " ▲" : " ▼")}
    </th>
  );
};
